import getStore from 'services/getStore';
import getActiveBlocks from 'services/apiHelpers/getActiveBlocks';

const getAllScoringInteractions = () => {
  let blocks;

  try {
    blocks = getActiveBlocks();
  } catch (err) {
    blocks = getStore().getState().blocks;
  }

  return (
    Object.values(blocks as any)
      // Object.values(getActiveBlocks() as any)
      // Object.values(getStore().getState().blocks as any)
      .filter((b: any) => b?.props.score && b?.props.score === true)
      .map((b: any) => b.id)
  );

  // console.log(getallScoringInteractions());
};

let score: {
  [key: string]: number;
} = {};

let dummyScore;

const setScore = (id, _scoreValue) => {
  const scoreValue = _scoreValue ? 1 : 0;
  score[id] = scoreValue;
};

const rehydrateScore = savedScore => {
  // Object.keys(savedScore).forEach(entry => {
  //   setScore(entry, savedScore[entry]);
  // });

  score = {
    ...score,
    ...savedScore,
  };
};

const getScore = (id?: number) => (id ? score[id] : score);

const getScoreRaw = () => {
  const us = Object.values(
    (getStore().getState().userBehaviour?.score as any) || {}
  );
  const scoreRaw = (us as any).reduce((acc, curr) => acc + curr, 0) || 0;

  return scoreRaw;
};

const getScorePercent = () =>
  (getScoreRaw() / getAllScoringInteractions().length) * 100 || 0;

const getDummyScore = () => {
  const parsedDummyScore = getScorePercent() || dummyScore;
  if (parsedDummyScore) {
    return Number(parsedDummyScore).toFixed();
  }

  return (dummyScore = (Math.random() * 100).toFixed());
};

export {
  setScore,
  rehydrateScore,
  getScore,
  getScoreRaw,
  getScorePercent,
  getAllScoringInteractions,
  getDummyScore,
};
